import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import AuthGateShell from "./shells/AuthGateShell";

export default function ProtectedRoute({ children }) {
  const { user, authReady } = useContext(AuthContext);
  const location = useLocation();

  // English: Show a visible shell while cookie-session bootstrap is running.
  if (!authReady) {
    return <AuthGateShell />;
  }

  // English: Preserve the exact page (including query/hash) for post-login return.
  if (!user) {
    const returnTo = `${location.pathname || "/"}${location.search || ""}${location.hash || ""}`;

    return (
      <Navigate
        to="/login"
        replace
        state={{ returnTo }}
      />
    );
  }

  return children;
}